'use client';

import { useTranslations } from 'next-intl';
import { MessageSquare } from 'lucide-react';
import {
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@/shared/ui/shadcn/dropdown-menu';
import { useQuickFeedbackStore } from '../model/quick-feedback.store';

/**
 * Phone-only twin of `FeedbackHeaderButton`, for a page's ⋮ menu: below `md`
 * the header has no room for a labelled action. Drop it into ANY page menu —
 * it hides itself from `md` up (where the header button already offers it) and
 * raises the app-shell dialog, so the page needs no state of its own.
 *
 * Mirrors Apple's `FeedbackMenuButton` and Android's `FeedbackMenuItem`.
 *
 * @param onSelect closes the host menu before the dialog opens.
 */
export function FeedbackMenuItem({ onSelect }: { onSelect?: () => void }) {
  const t = useTranslations('feedback');
  const open = useQuickFeedbackStore((state) => state.open);

  return (
    <>
      {/* Own separator: the item is the last entry of every menu it joins, and
          a menu that hides it must not keep a dangling separator. */}
      <DropdownMenuSeparator className="md:hidden" />
      <DropdownMenuItem
        className="md:hidden cursor-pointer"
        onClick={() => {
          onSelect?.();
          open();
        }}
      >
        <MessageSquare className="me-2 h-4 w-4" />
        {t('quick.button')}
      </DropdownMenuItem>
    </>
  );
}
